var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { throttle } from "lodash";
import { getAddressAutoSuggest } from "../../services/addressLookupService";
import { t } from '@mp/locale';
import { analytics } from "../../communication";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "../PropertyDetails/property-styles.scss";
import { TRACKING_NAMESPACE, trackingEvents, } from "../../services/schedulerService";
export default function AddressAutocomplete2(_a) {
    var addressString = _a.addressString, country = _a.country, onChange = _a.onChange, cookie = _a.cookie, reset = _a.reset, multipleSuggestions = _a.multipleSuggestions, props = __rest(_a, ["addressString", "country", "onChange", "cookie", "reset", "multipleSuggestions"]);
    var _b = useState(false), addressStarted = _b[0], setAddressStarted = _b[1];
    var _c = useState([]), suggestions = _c[0], setSuggestions = _c[1];
    var _d = useState(""), input = _d[0], setInput = _d[1];
    var _e = useState(0), forceRerender = _e[0], setForceRerender = _e[1];
    var _f = useState(null), value = _f[0], setValue = _f[1];
    useEffect(function () {
        if (cookie) {
            setInput(cookie);
            searchForAddress(null, cookie);
        }
    }, [cookie]);
    useEffect(function () {
        if ((addressString === null || addressString === void 0 ? void 0 : addressString.description) !== input) {
            setInput(addressString === null || addressString === void 0 ? void 0 : addressString.description);
            searchForAddress(null, addressString === null || addressString === void 0 ? void 0 : addressString.description);
        }
    }, [addressString === null || addressString === void 0 ? void 0 : addressString.description]);
    // Clear the inputs if user clicked in "Check another address"
    useEffect(function () {
        if (reset === "reset") {
            setInput("");
            setSuggestions([]);
            // need to force a rerender - extra info in the JSX code below
            setForceRerender(Date.now());
        }
    }, [reset]);
    var searchForAddress = (throttle(function (e, value) {
        var _a;
        if (!value) {
            setSuggestions([]);
            return;
        }
        getAddressAutoSuggest({
            country: country,
            address: value || ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value),
        })
            .then(function (results) {
            var _a;
            var suggestions = results;
            // If we don't have a match, prepend the search with no placeid
            if (!results.some(function (result) { var _a; return result.description === (value || ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value)); })) {
                suggestions = __spreadArray([
                    {
                        description: value || ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value),
                        placeid: 0
                    }
                ], results, true);
            }
            if (Array.isArray(suggestions)) {
                // The value of UK address from the finder are slightly different
                // Ex from finder: 10 Hanbury St, Greater London, England, E1 6QS, GB
                // Ex from lookup: 10 Hanbury St, London, Greater London E1 6QS, England, UK
                // Get the suggestion with a placeid
                var validSuggestion = suggestions.find(function (suggestion) { return suggestion.placeid; });
                // If we got cookies stored, start the order
                if (cookie && value === cookie && validSuggestion) {
                    startOrder(validSuggestion.description, validSuggestion.placeid);
                    setInput(validSuggestion.description);
                    setValue(validSuggestion.placeid);
                }
                setSuggestions(suggestions);
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    }, 700));
    var handleInputChange = function (e, value, reason) {
        // Don't clear the input when the component does a reset
        // We handle our own resets
        if (reason === 'reset') {
            return;
        }
        setValue(null);
        // Disable the next button
        // Force user to pick a new item
        multipleSuggestions('multiple');
        if (value === "" && reason === 'input') {
            setInput(value);
            setSuggestions([]);
            onChange(null, true);
            return;
        }
        if (!addressStarted) {
            analytics.track(TRACKING_NAMESPACE, trackingEvents.ADDRESS_STARTED, {});
            setAddressStarted(true);
        }
        setInput(value);
        searchForAddress(e, value);
    };
    var handleChange = function (event, placeid) {
        var _a;
        var description = ((_a = suggestions.find(function (suggestion) { return suggestion.placeid === placeid; })) === null || _a === void 0 ? void 0 : _a.description) || null;
        startOrder(description, placeid);
        setInput(description);
        setValue(placeid);
    };
    var startOrder = function (description, placeid) {
        var selection = {
            description: description,
            placeid: placeid
        };
        onChange(selection);
    };
    var handleBlur = function (e, reason) {
        var _a;
        if (reason === 'blur') {
            var input_1 = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            var _b = suggestions.find(function (suggestion) { return suggestion.description === input_1; }) || {}, description = _b.description, placeid = _b.placeid;
            startOrder(description, placeid);
            setInput(description);
            setValue(placeid);
        }
    };
    return (_jsx("div", __assign({ className: "full-width" }, { children: _jsx(Autocomplete, { id: "address", filterOptions: function (x) { return x; }, className: "mp-form-row-input", classes: { option: "catpure-services-autocomplete" }, disabled: !country, disableClearable: true, options: suggestions.map(function (suggestion) { return suggestion.placeid; }), getOptionLabel: function (option) {
                var _a;
                return ((_a = suggestions.find(function (suggestion) { return suggestion.placeid === option; })) === null || _a === void 0 ? void 0 : _a.description) || input;
            }, onClose: handleBlur, onChange: handleChange, onInputChange: handleInputChange, inputValue: input, value: value, renderInput: function (params) { return (_jsx(TextField, __assign({ variant: "standard", className: "scheduler-inputs", autoFocus: true }, params, { label: t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.addressString.label", "Address"), inputProps: __assign({}, params.inputProps) }))); } }, forceRerender) })));
}
